import { CSSProperties, FunctionComponent as FC, ReactNode } from 'react';
import { withStyles } from '../../../utils/utils';
import styles from './Card.module.scss';

const cn = withStyles(styles);

type CardProps = {
  title?: ReactNode;
  children: React.ReactNode | React.ReactNode[];
  style?: CSSProperties & {
    shadowOpacity?: number;
    dropShadow?: string;
  };
  className?: string;
  hoverEffect?: boolean;
  dataTestId?: string;
};

/**
 * Various styles are overridable by client (for iq11/cross-boarder, etc), hence the getCSSVar() everywhere.
 */
const Card: FC<CardProps> = ({ title, children, style = {}, className, hoverEffect = true, dataTestId }) => {
  function getCssVar(name: string) {
    return getComputedStyle(document.body).getPropertyValue(name);
  }

  return (
    <div
      data-testid={dataTestId}
      className={cn('cardContainer', className, hoverEffect !== undefined && hoverEffect && 'hoverEffect')}
      style={{
        '--shadowOpacity': getCssVar('--shadowOpacity') || style.shadowOpacity,
        '--cardDropShadow': getCssVar('--cardDropShadow') || style.dropShadow,
        ...style,
      }}
    >
      {title && <h2 className={cn('title')}>{title}</h2>}
      {children}
    </div>
  );
};

export default Card;
